<template>
  <svg :class="svgClass"
       v-on="$listeners">
    <use :xlink:href="iconName"/>
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName () {
      return `#icon-${this.iconClass}`
    },
    svgClass () {
      if (this.className) {
        return `svg-icon ${this.className}`
      } else {
        return 'svg-icon'
      }
    }
  }
}
</script>

<style lang="scss">
  .svg-icon {
    color: var(--theme-color, #606266);
    width: 24px;
    height: 24px;
    fill: currentColor;
    overflow: hidden;
  }
</style>
